import { render } from "./Main.vue?vue&type=template&id=3a2e1b23"
const script = {}
script.render = render

export default script